<template>
  <div>
    <div class="analysisItem">
      <div class="title">测评说明</div>
      <div class="explain" v-html="instruction"></div>
    </div>
    <div class="analysisItem">
      <div class="title">测评结果</div>
      <div class="explain" v-html="answerDimensionScore.suggestion"></div>
    </div>
    <div class="analysisItem flex justify-between items-center">
      <div class="title">得分分析</div>
      <div @click="showPopup" class="popupSelect">{{ chartTypeArr[chartType - 1] }}<van-icon name="arrow-down" /></div>
      <van-popup v-model="isShowPopup" position="bottom">
        <van-picker title="得分分析" show-toolbar :columns="chartTypeArr" @confirm="onConfirm" @cancel="onCancel" />
      </van-popup>
    </div>
    <analysis-chart ref="achart" :type="chartType" :source="chartSource" />
    <div class="analysisItem">
      <div class="title">维度分析</div>
      <div v-for="item in answerDimensionScore.details" class="dimensionAnalysis">
        <div class="leading-22 text-medium theme-black-850">{{ item.title }}</div>
        <div class="score">
          <span
            >得分：{{
              openStandardScore ? `${item.score} / 标准分：${item.standardScore === null ? 0 : item.standardScore}` : item.score
            }}</span
          >
        </div>
        <div class="dimensionSuggestion" v-html="item.suggestion"></div>
      </div>
      <!--      <div class="text-center mt-2" v-if="dimensionList.length === 3 && answerDimensionScore.details.length > 3">-->
      <!--        <a type="text" class="text-theme text-small" @click="getMore">查看更多</a>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { busGetters } from 'dygc'
import { chartTypeCode, chartTypes, chartTypeArr } from './chartType'
import AnalysisChart from './AnalysisChart'
export default {
  name: 'AnswerAnalysis',
  components: {
    AnalysisChart
  },
  data() {
    return {
      instruction: '',
      // dimensionList: [],
      chartTypes,
      chartTypeArr,
      chartType: chartTypeCode.LEIDA,
      isShowPopup: false
    }
  },
  methods: {
    // getMore() {
    //   this.dimensionList = this.answerDimensionScore.details
    // },
    showPopup() {
      this.isShowPopup = true
    },
    onConfirm(value, index) {
      this.chartType = (index + 1).toString()
      this.isShowPopup = false
    },
    onCancel() {
      this.isShowPopup = false
    }
  },
  computed: {
    ...busGetters(['answerDimensionScore', 'openStandardScore']),
    chartSource() {
      return this.answerDimensionScore.details
    }
  },
  mounted() {
    if (this.answerDimensionScore.instruction && this.answerDimensionScore.instruction[0] === '{') {
      this.instruction = JSON.parse(this.answerDimensionScore.instruction).instruction
    } else {
      this.instruction = this.answerDimensionScore.instruction
    }
    // if (this.answerDimensionScore.details.length > 3) {
    //   this.dimensionList = this.answerDimensionScore.details.slice(0, 3)
    // } else {
    //   this.dimensionList = this.answerDimensionScore.details
    // }
  }
}
</script>

<style lang="scss" scoped>
.analysisItem {
  @apply mt-6;
  .title {
    @apply font-medium leading-22 mb-2 text-medium text-theme-black-850;
  }
  .score {
    margin-top: 2px;
    margin-bottom: 6px;
    @apply text-theme-black-650;
    span {
      @apply text-small rounded-small bg-card-bg-gray p-1;
    }
  }
  .dimensionAnalysis {
    @apply pb-3 border-b border-black border-solid border-opacity-5 rounded-medium;
  }
  .explain {
    @apply text-theme-black-850 text-medium;
  }
  .dimensionSuggestion {
    @apply text-small text-theme-black-650;
  }
  .popupSelect {
    @apply text-small text-theme-text-gray w-w-22 h-6 bg-theme-gray rounded-small px-2 flex justify-between items-center;
  }
}
</style>
